function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _Object$freeze;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { BUTTON_CAD, BUTTON_USD, BUTTON_GBP, BUTTON_AUD, BUTTON_EUR, _LIGHT_GREY, _BLUE19, _RED16, _GREEN17, _AMBER18 } from "../components/style/colors";
export var PRODUCTION_ENV = process.env.NODE_ENV === 'production';
export var DOLLAR_SIGN = '$';
export var POUND_SIGN = '£';
export var CAD = 'CA$';
export var USD = 'US$';
export var AUD = 'AU$';
export var GBP = 'GB£';
export var EUR = 'EU€';
export var CAD_NEW = 'CAD';
export var USD_NEW = 'USD';
export var US_WORK_VISA_LINK = 'https://www.uscis.gov/working-united-states/students-and-exchange-visitors/students-and-employment';
export var UK_WORK_VISA_LINK = 'https://www.ukcisa.org.uk/Information--Advice/Working/Tier-4-work';
export var AU_WORK_VISA_LINK = 'https://www.studyinaustralia.gov.au/english/live-in-australia/working';
export var ACTIVE_COLOR = '#7ed321';
export var INACTIVE_COLOR = '#d0021b';
export var ACCOUNT_STUDENT = 'student_account';
export var ACCOUNT_AGENT = 'agent_account';
export var dateFormat = 'YYYY-MMM-DD';
export var dateTimeFormat = 'YYYY-MMM-DD HH:mm';
export var dateTimeSecondsFormat = 'YYYY-MM-DD HH:mm:ss';
export var API_ROOT = window.API_ROOT || '';
export var API_PREFIX = '/api/v0.1';
export var API_APPLICATION_PREFIX = "".concat(API_PREFIX, "/applications");
export var ButtonColor = {
  CAD: BUTTON_CAD,
  USD: BUTTON_USD,
  GBP: BUTTON_GBP,
  AUD: BUTTON_AUD,
  EUR: BUTTON_EUR
};
export var ENGLISH_TESTS_ORDER = {
  toefl: {
    R: 'reading',
    L: 'listening',
    S: 'speaking',
    W: 'writing'
  },
  ielts: {
    L: 'listening',
    R: 'reading',
    W: 'writing',
    S: 'speaking'
  },
  duolingo_english: {
    O: 'total'
  },
  pte: {
    L: 'listening',
    R: 'reading',
    W: 'writing',
    S: 'speaking',
    O: 'total'
  }
};
export var INTAKE_MONTHS = {
  fall: [8, 9, 10, 11],
  summer: [4, 5, 6, 7],
  winter: [12, 1, 2, 3]
};
export var OTHER_OPTIONS = [{
  label: 4,
  value: 4
}, {
  label: 5,
  value: 5
}, {
  label: 7,
  value: 7
}, {
  label: 10,
  value: 10
}, {
  label: 20,
  value: 20
}, {
  label: 100,
  value: 100
}];
export var SELECT_REQUIREMENT_MODAL_IDENTIFIER = 'select-requirement';
export var SELECT_REQUIREMENT_FILTER_IDENTIFIER = 'select-requirement-filter';
export var REMOVE_REQUIREMENT_MODAL_IDENTIFIER = 'remove-requirement';
export var APPLICATION_STATUSES = {
  'pre-payment': [{
    label: 'Undecided',
    value: 'undecided'
  }],
  'pre-submission': [{
    label: 'Undecided',
    value: 'undecided'
  }],
  submission: [{
    label: 'Undecided',
    value: 'undecided'
  }],
  'post-submission': [{
    label: 'Undecided',
    value: 'undecided'
  }],
  admission: [{
    label: 'Accepted',
    value: 'accepted'
  }],
  'visa-application': [{
    label: 'Accepted',
    value: 'accepted'
  }],
  'post-decision': [{
    label: 'Accepted',
    value: 'accepted'
  }],
  'pre-arrival': [{
    label: 'Accepted',
    value: 'accepted'
  }],
  refund: [{
    label: 'Accepted',
    value: 'accepted'
  }],
  general: [],
  deferral: []
};
export var APPLICATION_STATUS_OPTIONS = [{
  label: 'Undecided',
  value: 'undecided'
}, {
  label: 'Accepted',
  value: 'accepted'
}, {
  label: 'Rejected',
  value: 'rejected'
}, {
  label: 'Cancelled',
  value: 'cancelled'
}, {
  label: 'Withdrawn',
  value: 'withdrawn'
}];
export var REQUIREMENT_STATUSES = {
  'pre-payment': [{
    label: 'Pre-payment',
    value: 'pre-payment'
  }],
  'pre-submission': [{
    label: 'Pre-submission',
    value: 'pre-submission'
  }],
  submission: [{
    label: 'Submission',
    value: 'submission'
  }],
  'post-submission': [{
    label: 'Post-submission',
    value: 'post-submission'
  }],
  admission: [{
    label: 'Admission',
    value: 'admission'
  }],
  'visa-application': [{
    label: 'Visa-application',
    value: 'visa-application'
  }],
  'post-decision': [{
    label: 'Post-decision',
    value: 'post-decision'
  }],
  'pre-arrival': [{
    label: 'Pre-arrival',
    value: 'pre-arrival'
  }],
  refund: [{
    label: 'Refund',
    value: 'refund'
  }],
  general: [{
    label: 'General',
    value: 'general'
  }],
  deferral: [{
    label: 'Deferral',
    value: 'deferral'
  }]
};
export var REQUIREMENT_STATUS_OPTIONS = [{
  label: 'Pre-payment',
  value: 'pre-payment'
}, {
  label: 'Pre-submission',
  value: 'pre-submission'
}, {
  label: 'Submission',
  value: 'submission'
}, {
  label: 'Post-submission',
  value: 'post-submission'
}, {
  label: 'Admission',
  value: 'admission'
}, {
  label: 'Visa-application',
  value: 'visa-application'
}, {
  label: 'Post-decision',
  value: 'post-decision'
}, {
  label: 'Pre-arrival',
  value: 'pre-arrival'
}, {
  label: 'Arrival',
  value: 'arrival'
}, {
  label: 'Deferral',
  value: 'deferral'
}, {
  label: 'Refund',
  value: 'refund'
}, {
  label: 'General',
  value: 'general'
}];
export var ALL_UNDERGRADUATE_LEVELS = ['certificate', 'diploma', '3_year_bachelors', 'advanced_diploma', 'bachelors', 'english'];
export var ALL_K_12_LEVELS = ['grade_1', 'grade_10', 'grade_11', 'grade_12', 'grade_2', 'grade_3', 'grade_4', 'grade_5', 'grade_6', 'grade_7', 'grade_8', 'grade_9'];
export var NEW_SEARCH_COOKIE_NAME = 'useNewSearch2';
export var TUITIONS_TIP = 'Please be advised that the amount indicated below is an estimate provided by the school and subject to change. This amount varies based on the fixed amount from the school or net tuition the school recieves from the student.';
export var TUITION_FEE_DISCLAIMER = 'Please note that tuition fees may vary depending on the type and amount of courses that a student enrolls in. Tuition is subject to change without notice and annual increases.';
export var IntakeStatus = /*#__PURE__*/function (IntakeStatus) {
  IntakeStatus["OPEN"] = "open";
  IntakeStatus["OPEN_CONDITIONALLY"] = "open_conditionally";
  IntakeStatus["WILL_OPEN"] = "will_open";
  IntakeStatus["WILL_OPEN_CONDITIONALLY"] = "will_open_conditionally";
  IntakeStatus["CLOSED"] = "closed";
  IntakeStatus["CLOSED_CONDITIONALLY"] = "closed_conditionally";
  IntakeStatus["LIKELY_OPEN"] = "likely_open";
  IntakeStatus["WAITLIST"] = "waitlist";
  return IntakeStatus;
}({});
export var SOURCE_OF_DATE_LABEL = {
  email: 'Email',
  phone: 'Phone',
  intake_scraper: 'Intake Scraper',
  manual_check: 'Manual Check',
  new_program_for_active_school: 'New Program for Active School',
  submission_notification: 'Submission Notification',
  school_website: 'School Website',
  start_date_level_check: 'Start Date Level Check'
};
export var INTAKE_STATUS_DESCRIPTION = {
  open: 'Based on your profile information, the school is currently accepting applications for this intake. The school has been accepting applications for this intake since ',
  open_conditionally: 'Based on your profile information, the school is currently accepting applications for this intake. The school has been accepting applications for this intake since ',
  will_open: 'Based on your profile information, the school will start accepting applications for this intake on ',
  will_open_conditionally: 'Based on your profile information, the school will start accepting applications for this intake on ',
  closed: 'Based on your profile information, the submission deadline of this intake was SUBMISSION_DEADLINE, which is already passed.',
  closed_conditionally: 'Based on your profile information, the submission deadline of this intake was SUBMISSION_DEADLINE, which is already passed.',
  likely_open: 'The date in which the school starts accepting applications for this intake is still unknown',
  submission_deadline: 'Based on your profile information, the submission deadline of this intake is '
};
export var DEFAULT_OPEN_DATE_PASSED = 'The school has started to accept applications for this intake on ';
export var DEFAULT_OPEN_DATE_NOT_PASSED = 'The school will start accepting applications for this intake on ';
export var DEFAULT_OPEN_DATE_NOT_EXISTS = 'The date in which the school starts to accept applications for this intake is still unknown.';
export var PGWP_CANADA = 'Post-Grad Work Permit';
export var NO_PGWP_CANADA_TIP = 'Ineligible for Post-Grad Work Permit';
export var PGWP_UK = 'Post-Study Work Visa';
export var NO_PGWP_UK_TIP = 'Ineligible for Post-Study Work Visa';
export var PGWP_USA = 'Optional Practical Training';
export var NO_PGWP_USA_TIP = 'Ineligible for Optional Practical Training';

// Roles
export var SYS_ADMIN = 'sys_admin';
export var ADMIN = 'admin';
export var AGENT = 'agent';
export var AGENT_MANAGER = 'agent_manager';
export var AGENT_REGIONAL_MANAGER = 'agent_regional_manager';
export var STUDENT = 'student';
export var VISITOR = 'visitor';
export var INTERNATIONAL_RECRUITMENT_OFFICER = 'international_recruitment_officer';
export var EXTERNAL_CONTRACTOR = 'external_contractor';
export var CONTENT_EDITOR = 'content_editor';
export var STUDENT_ADVISOR = 'student_advisor';
export var SALES_PERSON = 'sales_person';

// Payments
export var ADDRESS = 'address';
export var AGENT_INFORMATION = 'agent_information';
export var APPLICATION = 'application';
export var BILLING_ACCOUNT = 'billing_account';
export var COMMISSION_POLICY = 'commission_policy';
export var COMMISSION_TIER = 'commission_tier';
export var DIRECT = 'Direct';
export var ORDER = 'order';
export var ORDER_ITEM = 'order_item';
export var PERSONAL_INFORMATION = 'personal_information';
export var PROGRAM = 'program';
export var RP = 'Recruitment Partner';
export var USER = 'User';
export var USER_TYPE = 'user';

// Applications
export var ApplicationRelationshipType = /*#__PURE__*/function (ApplicationRelationshipType) {
  ApplicationRelationshipType["USER"] = "user";
  ApplicationRelationshipType["AGENT_INFORMATION"] = "agent_information";
  ApplicationRelationshipType["PERSONAL_INFORMATION"] = "personal_information";
  ApplicationRelationshipType["ADDRESS"] = "address";
  ApplicationRelationshipType["SALES_REPRESENTATIVE"] = "sales_representative";
  ApplicationRelationshipType["STUDENT_INFORMATION"] = "student_information";
  ApplicationRelationshipType["PAYMENT"] = "payment";
  ApplicationRelationshipType["MANUAL_PAYMENT"] = "manual_payment";
  ApplicationRelationshipType["ORDER_ITEM"] = "order_item";
  ApplicationRelationshipType["APPLICATION_STAGE"] = "application_stage";
  ApplicationRelationshipType["PROGRAM"] = "program";
  ApplicationRelationshipType["SCHOOL"] = "school";
  ApplicationRelationshipType["APPLICATION_SERVICE_FEE_CHARGE"] = "application_service_fee_charge";
  ApplicationRelationshipType["APPLICATION_SERVICE_FEE"] = "application_service_fee";
  return ApplicationRelationshipType;
}({});
export var ACCEPTED_STATUS = 'Accepted';
export var REJECTED_STATUS = 'Rejected';
export var CANCELLED_STATUS = 'Cancelled';
export var WITHDRAWN_STATUS = 'Withdrawn';
export var REFUND_IN_PROGRESS_STATUS = 'Refund in Progress';
export var DEFERRAL_IN_PROGRESS_STATUS = 'Deferral in Progress';
export var WAITLISTED_STATUS = 'Waitlisted';
export var PROGRAM_CLOSED_STATUS = 'Program Closed';
export var SUBMITTED_STATUS = 'Submitted';
export var PROCESSING_STATUS = 'Processing...';
export var VERIFICATION_PENDING_STATUS = 'Verification Pending';
export var NOT_PAID_STATUS = 'Not Paid';
export var ENROLLMENT_CONFIRMED_STATUS = 'Enrollment Confirmed';
export var READY_TO_ENROLL_STATUS = 'Ready to Enroll';
export var YES_NO_OPTIONS = ['Yes', 'No'];
// this color mapping is used for requirements column in the /applications grid
//  which shows 4 dots representing different requirement counts
export var STATUS_COLOR_MAPPING = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, ACCEPTED_STATUS, _GREEN17), _defineProperty(_Object$freeze, CANCELLED_STATUS, _AMBER18), _defineProperty(_Object$freeze, DEFERRAL_IN_PROGRESS_STATUS, _AMBER18), _defineProperty(_Object$freeze, ENROLLMENT_CONFIRMED_STATUS, _GREEN17), _defineProperty(_Object$freeze, NOT_PAID_STATUS, _LIGHT_GREY), _defineProperty(_Object$freeze, PROCESSING_STATUS, _BLUE19), _defineProperty(_Object$freeze, PROGRAM_CLOSED_STATUS, _AMBER18), _defineProperty(_Object$freeze, READY_TO_ENROLL_STATUS, _GREEN17), _defineProperty(_Object$freeze, REFUND_IN_PROGRESS_STATUS, _AMBER18), _defineProperty(_Object$freeze, REJECTED_STATUS, _RED16), _defineProperty(_Object$freeze, SUBMITTED_STATUS, _GREEN17), _defineProperty(_Object$freeze, VERIFICATION_PENDING_STATUS, _LIGHT_GREY), _defineProperty(_Object$freeze, WAITLISTED_STATUS, _AMBER18), _defineProperty(_Object$freeze, WITHDRAWN_STATUS, _AMBER18), _Object$freeze));
export var REQUIREMENT_COLORS = [_AMBER18, _BLUE19, _RED16, _GREEN17];
export var TOEFL_NOT_REQUIRED_BAND_SCORE = 1;
export var IELTS_NOT_REQUIRED_BAND_SCORE = 1;
export var PTE_NOT_REQUIRED_BAND_SCORE = 10;
export var GMAT_NOT_REQUIRED_BAND_SCORE = 1;
export var APPLY_ASSIST_KNOWLEDGE_BASE_URL = 'https://zendesk-service.applyboard.com/api/v1/session/create?relay_state=https%3A%2F%2Fassist.applyboard.com';
export var APPLY_ASSIST_RECRUITER_NEWS_URL = 'https://zendesk-service.applyboard.com/api/v1/session/create?relay_state=https%3A%2F%2Fassist.applyboard.com/hc/en-us/categories/360004584614-Recruiter-News';
export var CONCORDIA_CONTINUING_EDUCATION_ID = 943;
export var STRIPE_INJECTABLE_SCRIPT_URL = 'https://js.stripe.com/v3/';
export var BRAINTREEGATEWAY_INJECTABLE_SCRIPT_URL = 'https://js.braintreegateway.com/web/3.25.0/js/client.min.js';